module.exports = __webpack_public_path__ + "static/img/6.0f641b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/6.png
// module id = OL9g
// module chunks = 0